import {WebCallService} from "@/utilities/system/services/WebCallService";
import {PathHelper} from "@/utilities/system/helpers/PathHelper";
import {
    ChangelogResponse,
    StartupConfigResponse
} from "@/models/system/api/Responses";
import {ErrorLocationType, HttpType} from "@/utilities/system/enums/Enums";
import {OidcMetadata} from "oidc-client";
import ErrorHandler from "@/utilities/system/helpers/ErrorHandler";

export class MiscService {
    private webCaller: WebCallService;
    private uriHelper: PathHelper;

    constructor(){
        this.webCaller = new WebCallService();
        this.uriHelper = new PathHelper();
    }

    public async getStartupConfig(errorLocationType:ErrorLocationType):Promise<StartupConfigResponse|null> {
        const uri = this.uriHelper.misc.getStartupConfigPath();

        const resp = await this.webCaller.HttpSend(HttpType.get, uri);
        if (resp === null || resp === undefined || (resp.statusCode !== undefined && resp.statusCode !== 0)) {
            ErrorHandler.handleError(resp, errorLocationType);
            return null;
        }

        return resp;
    }

    public async getChangelog():Promise<ChangelogResponse> {
        const uri = this.uriHelper.misc.getChangelogPath();

        return await this.webCaller.HttpSend(HttpType.get, uri);
    }

    public async getOidcMetaData(url:string):Promise<OidcMetadata> {
        return (await this.webCaller.GetFromExternalAPI(url)).data as OidcMetadata ;
    }

    public async getPubKey(errorLocationType:ErrorLocationType):Promise<string|null>{
        const uri = this.uriHelper.misc.getPubKeyPath();

        const resp = await this.webCaller.HttpSend(HttpType.get, uri);
        if (resp === null || resp === undefined || (resp.statusCode !== undefined && resp.statusCode !== 0)) {
            ErrorHandler.handleError(resp, errorLocationType);
            return null;
        }

        return resp;
    }
}
